import { API_SERVICE_STATUS } from '@/shared/constants/bff-endpoints';
import { useEffect, useRef, useState } from 'react';
import type { ServiceStatusCheck, ServiceStatusResponse } from './types';


const REQUEST_TIMEOUT_MS = 8_000;
const MAX_CHECKS         = 60;


export function useServiceStatusMonitor (intervalMs: number) {
    const [ checks, setChecks ] = useState<ServiceStatusCheck[]>([]);
    const mountedRef            = useRef(true);

    useEffect(() => {
        mountedRef.current = true;

        const runCheck = async () => {
            const controller = new AbortController();
            const timeout    = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

            try {
                const res  = await fetch(API_SERVICE_STATUS, {
                    cache : 'no-store',
                    signal: controller.signal,
                });
                const data = (await res.json()) as ServiceStatusResponse;

                if (mountedRef.current) {
                    setChecks((prev) =>
                        [ ...prev, { ...data, timestamp: Date.now() } ].slice(-MAX_CHECKS),
                    );
                }
            } catch {
                if (mountedRef.current) {
                    setChecks((prev) =>
                        [
                            ...prev,
                            { ok: false, status: 0, latency: 0, timestamp: Date.now(), clientError: true },
                        ].slice(-MAX_CHECKS),
                    );
                }
            } finally {
                clearTimeout(timeout);
            }
        };

        void runCheck();
        const id = setInterval(() => void runCheck(), intervalMs);

        return () => {
            mountedRef.current = false;
            clearInterval(id);
        };
    }, [ intervalMs ]);

    return { checks };
}
